import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { SPIRIT_DEFAULT_STATE } from './constants';

const completedState = completeState(SPIRIT_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [actions.GET_ALL_ADDED_SPIRITS, actions.ADD_SPIRIT],
  override: { [actions.SET_CURRENT_SPIRIT]: onReadValue() }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
